import React, { Component } from 'react';
import PropTypes from 'prop-types';

const TIMEOUT_DURATION = 15000;

class GoBackTimeout extends Component {
    timeout = null;
    componentDidMount() {
        this.timeout = setTimeout(() => {
            this.goBack();
        }, TIMEOUT_DURATION);
    }

    componentWillUnmount() {
        if(this.timeout) {
            clearInterval(this.timeout);
        }
    }

    render() {
        return(
            <div></div>
        )
    }

    goBack = () => {
        window.history.back();
    }
}

GoBackTimeout.propTypes = {
}

GoBackTimeout.defaultProps = {
}

export default GoBackTimeout;
